import { render } from "./app.vue?vue&type=template&id=ce4cabe2&scoped=true"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=ce4cabe2&scoped=true&lang=css"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce4cabe2"]])

export default __exports__